import React, { Component } from 'react';
import { connect } from "react-redux";
import moment from 'moment';
import classnames from "classnames";
import { get } from 'lodash'

import { mathTestFetchIfNeeded, mathTestSet } from './../../store/mathTest/actions';
import { profileFetchIfNeeded, profileUpdateStages } from './../../store/profile/actions';

import { ALPHABET } from './../../constants'
import Loader from './../shared/Loader'
import Button from './../shared/Button/index';
import baseStyles from 'custom/base.styl';
import Timer from './../LanguageTest/Timer';
import Radiobutton from './../shared/Radiobutton/index';

class PageMathTest extends Component {
  constructor(props) {
    super(props);

    this.state = { stateAnswer: null }

    this._handleOnClickNext = this._handleOnClickNext.bind(this);
    this._handleOnChange = this._handleOnChange.bind(this);
  }

  componentDidMount() {
    const { loadProfile, loadTest, mathTest } = this.props;
    loadProfile();
    if (!mathTest || !mathTest.status) {
      loadTest();
    }
  }

  _handleOnClickNext() {
    const { mathTest } = this.props;
    const data = {
      answer_id: mathTest.answer.answer_id,
      answer: this.state.stateAnswer,
    }
    this.props.nextStep(data);
    this.setState({ stateAnswer: null });
  }

  _handleOnChange(e) {
    this.setState({ stateAnswer: e.target.value });
  }

  timeout() {
    const { mathTest } = this.props;
    const data = {
      answer_id: mathTest.answer.answer_id,
      answer: -1,
    }
    this.props.nextStep(data);
  }

  render() {
    const { loading, mathTest, isSubmiting, endTime } = this.props;
    const { stateAnswer } = this.state;

    if (loading) {
      return <Loader absolute />
    }
    if (!mathTest) {
      return null
    }

    const { answers, progress, question } = mathTest

    if (mathTest.status === 'success') {
      return (
        <div className={classnames(baseStyles.content_board, baseStyles.centered, baseStyles.modal, baseStyles.modal_space)}>
          <h1>Thank you for completing the test!</h1>
          <p>The most difficult part is over! <br />Since you are entering the last stage of our testing environment, we would like to know a bit more about you.</p>
          <Button onClick={() => this.props.profileUpdateStages()} block>Next stage</Button>
        </div>
      )
    }

    if (mathTest.status === 'timeout') {
      return (
        <div className={classnames(baseStyles.content_board, baseStyles.centered, baseStyles.modal, baseStyles.modal_space)}>
          <h1 className={baseStyles.fail}>Time is out!;(</h1>
          <p>Unfortunately, you’ve run out of time, therefore the next stage is unavailable. Take your time to improve your knowledge in this subject and reapply once you feel confident in your skills!</p>
          <Button onClick={() => this.props.profileUpdateStages()} block>Next stage</Button>
        </div>
      )
    }

    return (
      <div className={classnames(baseStyles.content_board, baseStyles.centered, baseStyles.testing, baseStyles.finance_testing)}>
        {progress &&
          <div className={baseStyles.test_header}>{progress.complete + 1} / {progress.total}</div>
        }

        <h2 className={baseStyles.test_title}>{mathTest.answer.data.question}</h2>

        <div className={baseStyles.test_body}>
          {(answers || []).map((number) =>
            <div className={baseStyles.radio_wrap} key={number}>
              <Radiobutton
                checked={stateAnswer === number.toString()}
                onChange={this._handleOnChange}
                type="radio"
                id={mathTest.answer.answer_id}
                name={mathTest.answer.answer_id}
                value={number}
              >{mathTest.answer.data[`answer${number}`]}</Radiobutton>
            </div>
          )}
        </div>

        <Button onClick={this._handleOnClickNext} disabled={isSubmiting || !stateAnswer}>Next</Button>

        {endTime &&
          <div className={baseStyles.test_footer}>Time left: <Timer endTime={endTime} submitTest={() => this.timeout()} /></div>
        }
      </div>
    )
  }
}

const mapStateToProps = state => {
  const loadingProfile = get(state.profile, 'data.isFetching');
  const hasProfile = !!(get(state.profile, 'data.user.id'));
  const profile = get(state.profile, 'data.user');

  const mathTest = state.mathTest;
  let endTime = null;
  if (profile && profile.profile.finance_text_test_timestamp) {
    const startTime = profile && profile.profile.finance_text_test_timestamp;
    endTime = moment.unix(startTime).add(30, 'minutes').format();
  }

  return {
    loading: loadingProfile || mathTest.isFetching,
    isSubmiting: mathTest.isSubmiting,
    mathTest,
    hasProfile,
    endTime,
  }
};

const mapDispatchToProps = dispatch => ({
  loadProfile: () => {
    dispatch(profileFetchIfNeeded());
  },
  loadTest: () => dispatch(mathTestFetchIfNeeded()),
  nextStep: (data) => dispatch(mathTestSet(data)),
  profileUpdateStages: () => { dispatch(profileUpdateStages()) },
});

export default connect(mapStateToProps, mapDispatchToProps)(PageMathTest)



// WEBPACK FOOTER //
// ./src/components/FinanceTest/PageFinanceTextTest.js